import { render, staticRenderFns } from "./ProductGetView.vue?vue&type=template&id=200d5d3f"
import script from "./ProductGetView.vue?vue&type=script&lang=js"
export * from "./ProductGetView.vue?vue&type=script&lang=js"
import style0 from "./ProductGetView.vue?vue&type=style&index=0&id=200d5d3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports